import React from 'react';
import PropTypes from 'prop-types';
import TableHeading from '../../modules/DataTable/components/TableHeading';

function StatisticsVendorsHeader(props) {
    function findColumnData(name, filter) {
        if (filter) {
            return props.children.find(element => element.name === filter);
        }
        return props.children.find(element => element.name === name);
    }
    function getCellClassName(cellName) {
        return 'ui-table__cell statsVendors__cell statsVendors__headCell '
            + `statsVendors__cell_${cellName} statsVendors__headCell_${cellName}`;
    }

    return (
        <thead>
            <tr>
                <th
                    className={getCellClassName('expand')}
                    data-title="expand"
                />
                <TableHeading
                    onSort={props.onSort}

                    {...findColumnData(
                        props.columns[1].columnName,
                        props.columns[1].filterBy)
                    }
                    {...props.columns[1]}
                />
                <TableHeading
                    onSort={props.onSort}

                    {...findColumnData(
                        props.columns[2].columnName,
                        props.columns[2].filterBy)
                    }
                    {...props.columns[2]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[3].columnName,
                        props.columns[3].filterBy)
                    }
                    {...props.columns[3]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[4].columnName,
                        props.columns[4].filterBy)
                    }
                    {...props.columns[4]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[5].columnName,
                        props.columns[5].filterBy)
                    }
                    {...props.columns[5]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[6].columnName,
                        props.columns[6].filterBy)
                    }
                    {...props.columns[6]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[7].columnName,
                        props.columns[7].filterBy)
                    }
                    {...props.columns[7]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[8].columnName,
                        props.columns[8].filterBy)
                    }
                    {...props.columns[8]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[9].columnName,
                        props.columns[9].filterBy)
                    }
                    {...props.columns[9]}
                />
            </tr>
        </thead>
    );
}

StatisticsVendorsHeader.propTypes = {
    children: PropTypes.array,
    columns: PropTypes.array,
    sortLink: PropTypes.any,
    onSort: PropTypes.func,
    columnName: PropTypes.string,
    filterBy: PropTypes.string
};

export default StatisticsVendorsHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsVendorsHeader.js